import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M11.888 21S2 16.953 2 9.58C1.98 6.493 4.35 4 7.27 4c2.063 0 3.86 1.268 4.72 3.106C12.847 5.268 14.645 4 16.71 4 19.628 4 22 6.493 22 9.578 22 16.914 11.888 21 11.888 21" }, null, -1)
  ])))
}
export default { render: render }